import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent  from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import ThemeColors from './ThemeColors';

import PageTitle from './PageTitle';
import TopLinearLoading from './TopLinearLoading';

const styles = theme => ({
  loginContainer: {
    [theme.breakpoints.down('xs')]: {
      padding: 0,
      position: "fixed",
      height: "100%",
      zIndex: 1,
      display: "flex",
      alignItems: "center",
      width: "100%"
    }
  },
  loginCard: {
    position: "relative",
    backgroundColor: "#fff",
    zIndex: 1,
    [theme.breakpoints.up('sm')]: {
      width: 400,
      position: "absolute",
      left: "50%",
      marginLeft: -200,
      top: 70
    },
    [theme.breakpoints.down('xs')]: {
      boxShadow: "none",
      backgroundColor: "transparent",
      width: "100%"
    },
  },
  header: { marginBottom: 0},
  headline: {
    marginBottom: 10,
    color:ThemeColors.primary,
    fontWeight: 100
  },
  signUp: {
    textAlign: "center", 
    margin: 0, 
    marginTop: 100,
    color: "#000", textDecoration: "none", fontSize: 14,
    [theme.breakpoints.up('sm')]: {
      marginTop: 20,
    },
  },
  secondaryLink: {
    marginBottom: 10,
    cursor: "pointer",
    color: '#42A5F5'
  },
  subheading:{
    color: "#000",
    marginTop: 10
  }
});

const FloatingLoginCard = ({ children, secondaryActions, classes, heading, subheading, isLoading = false }) => (
  <div className={classes.loginContainer}>
    {isLoading && <Hidden smUp><TopLinearLoading/></Hidden>}
    <Card className={classes.loginCard}>
      {isLoading && <Hidden xsDown><TopLinearLoading/></Hidden>}
      <div>
        <CardContent>
          <div className={classes.header}>
            <PageTitle title={heading} />
            <Typography className={classes.subheading}>{subheading}</Typography>
          </div>
          <div>{children}</div>
          {secondaryActions.length > 0 && 
            <div className={classes.signUp}>
              {secondaryActions.map((action, i) => (
                <div key={i} className={classes.secondaryLink}>
                  <a onClick={action.onClick}>{action.text}</a>
                </div>
              ))}
            </div>
          }
        </CardContent>
      </div>
    </Card>
  </div>
);

export default withStyles(styles)(FloatingLoginCard);